// extracted by mini-css-extract-plugin
export default {"paper":"jFW435UFOTTdWTPnDeLV","paperTitleWrapper":"ZM7yv1e45D4ipdGsNA65","paperTitle":"CPr75GcGZdNDnLmu20Fp","flex":"TMbZkQdtfw94DgJYAb62","content":"C2BbEttLonjPnd9ekyW2"};